import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip, LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';
import { FaUsers, FaUserPlus, FaUserMinus, FaUserClock } from 'react-icons/fa';

const COLORS = ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6c757d'];

const EmployeeWidget = ({ data }) => {
  const pieData = data?.byDepartment?.map((item, index) => ({
    name: item.department,
    value: item.count,
    color: COLORS[index % COLORS.length]
  })) || [];

  return (
    <div className="employee-widget-content h-100 p-1 p-md-2">
      <Row className="g-2 g-md-3 mb-3 mb-md-4 text-center">
        <Col xs={6}>
          <div className="p-2 p-md-3 rounded-4 bg-light border border-white shadow-sm">
            <FaUsers size={20} className="text-primary mb-1 mb-md-2" />
            <h4 className="mb-0 fw-bold fs-5 fs-md-4">{data?.active || 0}</h4>
            <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.65rem' }}>Active</small>
          </div>
        </Col>
        <Col xs={6}>
          <div className="p-2 p-md-3 rounded-4 bg-light border border-white shadow-sm">
            <FaUserPlus size={20} className="text-success mb-1 mb-md-2" />
            <h4 className="mb-0 fw-bold fs-5 fs-md-4">{data?.newJoinings || 0}</h4>
            <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.65rem' }}>New Hires</small>
          </div>
        </Col>
        <Col xs={6}>
          <div className="p-2 p-md-3 rounded-4 bg-light border border-white shadow-sm">
            <FaUserMinus size={20} className="text-danger mb-1 mb-md-2" />
            <h4 className="mb-0 fw-bold fs-5 fs-md-4">{data?.resignations || 0}</h4>
            <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.65rem' }}>Exits</small>
          </div>
        </Col>
        <Col xs={6}>
          <div className="p-2 p-md-3 rounded-4 bg-light border border-white shadow-sm">
            <FaUserClock size={20} className="text-warning mb-1 mb-md-2" />
            <h4 className="mb-0 fw-bold fs-5 fs-md-4">{data?.probation || 0}</h4>
            <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.65rem' }}>Probation</small>
          </div>
        </Col>
      </Row>

      {pieData.length > 0 ? (
        <div className="chart-area mt-2">
          <h6 className="fw-bold mb-3 text-dark small text-uppercase text-center">Departmental Distribution</h6>
          <ResponsiveContainer width="100%" height={180}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={true}
                outerRadius={65}
                innerRadius={45} // Donut style looks more premium
                fill="#8884d8"
                dataKey="value"
                paddingAngle={5}
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="text-center py-4 bg-light rounded-4 opacity-75 italic text-muted">
          No departmental data recorded
        </div>
      )}
    </div>
  );
};

export default EmployeeWidget;
